import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=741d0836&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d0836",
  null
  
)

export default component.exports